// TabManager import
import { TabManager } from "./TabManger.js";
import { initPhoneFormatting } from "./util/helper.js";
import {
  submitPartnershipInquiry,
  submitBookingInquiry,
  submitSimpleInquiry,
} from "./util/request.js";
import {
  initRequireLoginLinks,
  bindRequireLoginToContainer,
} from "./util/loginCheck.js";

$(document).ready(function () {
  new daum.roughmap.Lander({
    timestamp: "1763023656799",
    key: "c52njhin398",
  }).render();

  AOS.init();
  gsap.registerPlugin(ScrollTrigger);
  initHeader();
  const lenis = initLenis();
  initSwipers();
  initBeforeAfterTabs();
  initTabManager(lenis);
  initMarquee();
  initReviewMarquee();
  initBreadcrumb();
  initHistoryTimeline();
  initFloatingAside(lenis);

  formHandler();
  initBaseFaq();
  initBeerSlider();
  initPhoneFormatting(); // 전화번호 자동 하이픈 포맷팅
  initPartnershipForm(); // 제휴 문의 폼 처리
  initBookingForm(); // 온라인 예약 폼 처리
  initSimpleInquiryForm(); // 간편 문의 폼 처리
  initRequireLoginLinks(); // 로그인 필요 링크 초기화

  // jQuery + jQuery UI 로드된 상태 가정
  $(function () {
    // 날짜
    $(".js-datepicker").datepicker({
      dateFormat: "yy-mm-dd",
    });

    // 아이콘 클릭 시 datepicker 열기
    $(".js-open-datepicker").on("click", function () {
      $(this).siblings(".js-datepicker").datepicker("show");
    });

    // 시간 dropdown 초기화
    initTimeDropdown();
  });
});

function initBaseFaq() {
  const lists = document.querySelectorAll(".no-faq__list");
  if (!lists.length) return;

  lists.forEach((list) => {
    const items = list.querySelectorAll(".no-faq__item");
    if (!items.length) return;

    items.forEach((item) => {
      const head = item.querySelector(".no-faq__head");
      if (!head) return;

      head.addEventListener("click", () => {
        const isActive = item.classList.contains("--active");

        // 다른 항목 닫기
        items.forEach((sibling) => sibling.classList.remove("--active"));

        // 현재 항목 토글
        if (!isActive) {
          item.classList.add("--active");
        }
      });
    });
  });
}

function formHandler() {
  const form = document.querySelector("form");
  if (!form) {
    return;
  }

  const reloadingButton = document.getElementById("reloading");
  if (!reloadingButton) {
    return;
  }
  const captchaImg = document.querySelector("#captcha-img");

  reloadingButton.addEventListener("click", () => {
    const base = "/inc/lib/captcha.n.php";
    captchaImg.src = base + "?_=" + Date.now();
  });
}

// 캡차 새로고침 함수 (전역으로 노출)
window.refreshCaptcha = function () {
  const captchaImg = document.getElementById("captcha-img");
  if (captchaImg) {
    captchaImg.src = "/inc/lib/captcha.n.php?t=" + new Date().getTime();
  }
};

// 제휴 문의 폼 처리
function initPartnershipForm() {
  const form = document.querySelector('form[action*="request.partner"]');
  if (!form) return;

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    const submitButton = form.querySelector("button[type='submit']");
    const originalText = submitButton.textContent;

    // 버튼 비활성화
    submitButton.disabled = true;
    submitButton.textContent = "처리 중...";

    try {
      const formData = new FormData(form);
      const result = await submitPartnershipInquiry(formData);

      if (result.success) {
        alert("문의가 정상적으로 접수되었습니다.");
        form.reset();
        refreshCaptcha(); // 캡차 새로고침
      } else {
        alert(result.message || "문의 접수 중 오류가 발생했습니다.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("네트워크 오류입니다.");
    } finally {
      // 버튼 활성화
      submitButton.disabled = false;
      submitButton.textContent = originalText;
    }
  });
}

// 온라인 예약 폼 처리
function initBookingForm() {
  const form = document.querySelector(
    'form[action*="request.booking"], form[action=""]'
  );
  if (!form) return;

  // 예약 폼인지 확인 (visit_date 필드가 있는지)
  const visitDateField = form.querySelector('input[name="visit_date"]');
  if (!visitDateField) return;

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    const submitButton = form.querySelector("button[type='submit']");
    const originalText = submitButton.textContent;

    // 버튼 비활성화
    submitButton.disabled = true;
    submitButton.textContent = "처리 중...";

    try {
      const formData = new FormData(form);
      const result = await submitBookingInquiry(formData);

      if (result.success) {
        alert("예약이 정상적으로 접수되었습니다.");
        form.reset();
        refreshCaptcha(); // 캡차 새로고침
      } else {
        alert(result.message || "예약 접수 중 오류가 발생했습니다.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("네트워크 오류입니다.");
    } finally {
      // 버튼 활성화
      submitButton.disabled = false;
      submitButton.textContent = originalText;
    }
  });
}

// 간편 문의 폼 처리
function initSimpleInquiryForm() {
  const form = document.querySelector("#simple-inquiry-form");
  if (!form) return;

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    const submitButton = form.querySelector("button[type='submit']");
    const originalText = submitButton.textContent;

    // 버튼 비활성화
    submitButton.disabled = true;
    submitButton.textContent = "처리 중...";

    try {
      const formData = new FormData(form);
      const result = await submitSimpleInquiry(formData);

      if (result.success) {
        alert("문의가 정상적으로 접수되었습니다.");
        form.reset();
      } else {
        alert(result.message || "문의 접수 중 오류가 발생했습니다.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("네트워크 오류입니다.");
    } finally {
      // 버튼 활성화
      submitButton.disabled = false;
      submitButton.textContent = originalText;
    }
  });
}

function initTimeDropdown() {
  const dropdowns = document.querySelectorAll(".no-time-dropdown");

  dropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector(".no-time-dropdown__trigger");
    const text = dropdown.querySelector(".no-time-dropdown__text");
    const icon = dropdown.querySelector(".no-time-dropdown__icon");
    const list = dropdown.querySelector(".no-time-dropdown__list");
    const items = dropdown.querySelectorAll(".no-time-dropdown__item");
    const hiddenInput = dropdown.querySelector('input[type="hidden"]');

    if (!trigger || !list || !hiddenInput) return;

    // trigger 클릭 시 focus
    trigger.addEventListener("click", () => {
      trigger.focus();
    });

    // focus 시 드롭다운 표시
    trigger.addEventListener("focus", () => {
      list.style.display = "block";
      icon.style.transform = "rotate(180deg)";
      trigger.setAttribute("aria-expanded", "true");
    });

    // blur 시 드롭다운 숨김 (약간의 지연을 두어 클릭 이벤트가 먼저 발생하도록)
    trigger.addEventListener("blur", () => {
      setTimeout(() => {
        if (!dropdown.contains(document.activeElement)) {
          list.style.display = "none";
          icon.style.transform = "rotate(0deg)";
          trigger.setAttribute("aria-expanded", "false");
        }
      }, 200);
    });

    // 아이템 클릭 시
    items.forEach((item) => {
      item.addEventListener("click", () => {
        const value = item.getAttribute("data-value");

        // hidden input에 값 저장
        hiddenInput.value = value;

        // 텍스트 업데이트
        text.textContent = value;

        // active 클래스 업데이트
        items.forEach((i) => i.classList.remove("active"));
        item.classList.add("active");

        // 드롭다운 닫기
        list.style.display = "none";
        icon.style.transform = "rotate(0deg)";
        trigger.setAttribute("aria-expanded", "false");

        // trigger에서 focus 제거
        trigger.blur();
      });
    });
  });
}

function initHeader() {
  const header = document.getElementById("main-header");

  if (!header) return;

  const nav = header.querySelector(".no-header__nav");

  if (!nav) return;

  // 타임라인 생성 함수
  const createTimeline = () => {
    const timeline = gsap.timeline({ paused: true });
    timeline.to(header, {
      height: () => {
        return nav.offsetHeight + "px";
      },
      ease: "power3.inOut",
    });
    return timeline;
  };

  let tl = createTimeline();

  // 모바일/데스크톱 감지 함수
  const isMobile = () => window.innerWidth <= 1024;

  // 헤더 높이 초기화 함수
  const resetHeaderHeight = () => {
    if (tl.isActive()) {
      tl.progress(0);
      tl.pause();
    }
    gsap.set(header, { clearProps: "height" });
    header.removeAttribute("aria-expanded");
  };

  const onEnter = () => {
    if (isMobile()) return; // 모바일에서는 작동하지 않음
    header.setAttribute("aria-expanded", true);
    tl.play();
  };

  const onLeave = () => {
    if (isMobile()) return; // 모바일에서는 작동하지 않음
    header.removeAttribute("aria-expanded");
    tl.reverse();
  };

  // 이벤트 리스너 관리
  let mouseEnterHandler = null;
  let mouseLeaveHandler = null;

  const setupHeaderEvents = () => {
    // 기존 이벤트 리스너 제거
    if (mouseEnterHandler) {
      header.removeEventListener("mouseenter", mouseEnterHandler);
      header.removeEventListener("mouseleave", mouseLeaveHandler);
    }

    if (!isMobile()) {
      // 데스크톱: 마우스 이벤트 추가
      mouseEnterHandler = onEnter;
      mouseLeaveHandler = onLeave;
      header.addEventListener("mouseenter", mouseEnterHandler);
      header.addEventListener("mouseleave", mouseLeaveHandler);
    } else {
      // 모바일: 헤더 높이 초기화
      resetHeaderHeight();
    }
  };

  // 헤더 리사이즈 처리 함수
  const handleHeaderResize = () => {
    const wasMobile = mouseEnterHandler === null;
    const nowMobile = isMobile();

    // 모바일/데스크톱 전환 시에만 재설정
    if (wasMobile !== nowMobile) {
      setupHeaderEvents();
    } else if (nowMobile) {
      // 모바일에서 리사이즈 시에도 헤더 높이 초기화
      resetHeaderHeight();
    } else {
      // 데스크톱에서 리사이즈 시: 타임라인 재생성 및 이벤트 재설정
      // 현재 진행 상태 저장
      const wasPlaying = tl.isActive();
      const currentProgress = tl.progress();

      // 타임라인 재생성
      tl.kill();
      tl = createTimeline();

      // 이전 상태 복원
      if (wasPlaying) {
        tl.progress(currentProgress);
        tl.play();
      }

      // 이벤트 리스너 재설정
      setupHeaderEvents();
    }
  };

  // 초기 설정
  setupHeaderEvents();

  // 리사이즈 처리 (디바운스 적용)
  let resizeTimer = null;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      handleHeaderResize();
    }, 150);
  });

  const drawer = document.getElementById("main-drawer");
  const search = document.getElementById("main-search");
  const modalCloseBtn = document.querySelector(".no-modal__close");

  let drawerTl = null;
  let searchTl = null;

  if (drawer) {
    drawerTl = gsap.timeline({ paused: true });
    // 열기 애니메이션: visibility 먼저 설정 후 transform, opacity 애니메이션
    drawerTl.set(drawer, { visibility: "visible" });
    drawerTl.to(drawer, {
      x: "0%",
      opacity: 1,
      ease: "power3.inOut",
      duration: 0.3,
    });
    // 닫기 완료 시 visibility 숨김 (한 번만 설정)
    drawerTl.eventCallback("onReverseComplete", () => {
      gsap.set(drawer, { visibility: "hidden" });
    });
  }

  if (search) {
    searchTl = gsap.timeline({ paused: true });
    // 열기 애니메이션: visibility 먼저 설정 후 opacity 애니메이션
    searchTl.set(search, { visibility: "visible" });
    searchTl.to(search, {
      opacity: 1,
      ease: "power3.inOut",
      duration: 0.3,
    });
    // 닫기 완료 시 visibility 숨김 (한 번만 설정)
    searchTl.eventCallback("onReverseComplete", () => {
      gsap.set(search, { visibility: "hidden" });
      search.classList.remove("is-open");
    });
  }

  // 공통 열기/닫기 함수들
  const openDrawer = () => {
    if (!drawer || !drawerTl) return;
    document.body.classList.add("--hidden");
    drawer.setAttribute("data-state", "open");
    drawerTl.play();
    if (modalCloseBtn) {
      modalCloseBtn.classList.add("is-visible");
    }
  };

  const closeDrawer = () => {
    if (!drawer || !drawerTl) return;
    drawerTl.reverse();
    drawer.setAttribute("data-state", "closed");
    document.body.classList.remove("--hidden");
    if (modalCloseBtn) {
      modalCloseBtn.classList.remove("is-visible");
    }
  };

  const openSearch = () => {
    if (!search || !searchTl) return;
    document.body.classList.add("--hidden");
    search.setAttribute("data-state", "open");
    search.classList.add("is-open");
    searchTl.play();
    // 모달 닫기 버튼 표시 (search 내부의 버튼도 확인)
    const searchCloseBtn = search.querySelector(".no-modal__close");
    if (searchCloseBtn) {
      searchCloseBtn.classList.add("is-visible");
    }
    if (modalCloseBtn) {
      modalCloseBtn.classList.add("is-visible");
    }
    // 포커스를 검색 입력 필드로 이동
    const searchInput = search.querySelector(".no-search__input");
    if (searchInput) {
      setTimeout(() => {
        searchInput.focus();
      }, 100);
    }
    // 검색 히스토리 로드
    loadSearchHistory();
  };

  const closeSearch = () => {
    if (!search || !searchTl) return;
    searchTl.reverse();
    search.setAttribute("data-state", "closed");
    document.body.classList.remove("--hidden");
    // 모달 닫기 버튼 숨김 (search 내부의 버튼도 확인)
    const searchCloseBtn = search.querySelector(".no-modal__close");
    if (searchCloseBtn) {
      searchCloseBtn.classList.remove("is-visible");
    }
    if (modalCloseBtn) {
      modalCloseBtn.classList.remove("is-visible");
    }
  };

  // 검색 히스토리 관련 함수들
  async function loadSearchHistory() {
    const historyContainer = document.getElementById("searchHistory");
    const historyList = document.getElementById("searchHistoryList");

    if (!historyContainer || !historyList) return;

    try {
      const response = await fetch("/api/search-history-list.php");
      const result = await response.json();

      if (result.success && result.data && result.data.length > 0) {
        historyList.innerHTML = "";
        result.data.forEach((item) => {
          const li = document.createElement("li");
          li.className = "no-search__history-item";
          li.innerHTML = `
            <a href="/search?q=${encodeURIComponent(
              item.search_keyword
            )}" class="no-search__history-keyword">
              ${escapeHtml(item.search_keyword)}
            </a>
            <button type="button" class="no-search__history-delete" data-id="${
              item.id
            }" aria-label="삭제">
              <i class="fa-regular fa-xmark"></i>
            </button>
          `;
          historyList.appendChild(li);
        });
        historyContainer.style.display = "block";
      } else {
        historyContainer.style.display = "none";
      }
    } catch (error) {
      console.error("검색 히스토리 로드 실패:", error);
      historyContainer.style.display = "none";
    }
  }

  function escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }

  async function deleteSearchHistory(historyId) {
    try {
      const response = await fetch("/api/search-history-delete.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: historyId }),
      });

      const result = await response.json();

      if (result.success) {
        loadSearchHistory(); // 히스토리 다시 로드
      } else {
        alert(result.message || "삭제에 실패했습니다.");
      }
    } catch (error) {
      console.error("검색 히스토리 삭제 실패:", error);
      alert("삭제 중 오류가 발생했습니다.");
    }
  }

  async function clearAllSearchHistory() {
    if (!confirm("모든 검색 히스토리를 삭제하시겠습니까?")) {
      return;
    }

    const historyList = document.getElementById("searchHistoryList");
    if (!historyList) return;

    const items = historyList.querySelectorAll(".no-search__history-item");
    const deletePromises = Array.from(items).map((item) => {
      const deleteBtn = item.querySelector(".no-search__history-delete");
      const historyId = deleteBtn?.getAttribute("data-id");
      if (historyId) {
        return deleteSearchHistory(historyId);
      }
    });

    await Promise.all(deletePromises);
    loadSearchHistory(); // 히스토리 다시 로드
  }

  // 검색 히스토리 이벤트 리스너
  if (search) {
    // 개별 삭제
    search.addEventListener("click", (e) => {
      const deleteBtn = e.target.closest(".no-search__history-delete");
      if (deleteBtn) {
        e.preventDefault();
        e.stopPropagation();
        const historyId = deleteBtn.getAttribute("data-id");
        if (historyId) {
          deleteSearchHistory(historyId);
        }
      }
    });

    // 전체 삭제
    const clearAllBtn = document.getElementById("clearAllHistory");
    if (clearAllBtn) {
      clearAllBtn.addEventListener("click", (e) => {
        e.preventDefault();
        clearAllSearchHistory();
      });
    }
  }

  // Drawer 열기
  if (drawer && drawerTl) {
    const drawerOpenBtn = header.querySelector(".no-header__toggle");

    if (drawerOpenBtn) {
      drawerOpenBtn.addEventListener("click", () => {
        // search가 열려있으면 먼저 닫기
        if (search && search.getAttribute("data-state") === "open") {
          closeSearch();
          // search가 닫힐 때까지 대기 후 drawer 열기
          setTimeout(() => {
            openDrawer();
          }, 300);
        } else {
          openDrawer();
        }
      });
    }
  }

  // Search 열기
  if (search && searchTl) {
    const searchOpenBtn = header.querySelector(".no-header__search-toggle");

    if (searchOpenBtn) {
      searchOpenBtn.addEventListener("click", () => {
        // drawer가 열려있으면 먼저 닫기
        if (drawer && drawer.getAttribute("data-state") === "open") {
          closeDrawer();
          // drawer가 닫힐 때까지 대기 후 search 열기
          setTimeout(() => {
            openSearch();
          }, 300);
        } else {
          openSearch();
        }
      });
    }
  }

  // 공통 닫기 버튼 이벤트 (헤더의 버튼)
  if (modalCloseBtn) {
    modalCloseBtn.addEventListener("click", () => {
      // search가 열려있으면 search 닫기 (우선순위)
      if (search && search.getAttribute("data-state") === "open") {
        closeSearch();
      } else if (drawer && drawer.getAttribute("data-state") === "open") {
        // drawer가 열려있으면 drawer 닫기
        closeDrawer();
      }
    });
  }

  // Search 내부의 닫기 버튼 이벤트
  if (search) {
    const searchCloseBtn = search.querySelector(".no-modal__close");
    if (searchCloseBtn) {
      searchCloseBtn.addEventListener("click", () => {
        closeSearch();
      });
    }
  }

  // ESC 키로 닫기
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      if (search && search.getAttribute("data-state") === "open") {
        closeSearch();
      } else if (drawer && drawer.getAttribute("data-state") === "open") {
        closeDrawer();
      }
    }
  });

  // Drawer 내 다국어 드롭다운 초기화
  if (drawer) {
    const drawerLangBtn = drawer.querySelector(".no-drawer__lang-btn");
    const drawerLang = drawer.querySelector(".no-drawer__lang");
    const drawerLangDropdown = drawer.querySelector(
      ".no-drawer__lang-dropdown"
    );

    if (drawerLangBtn && drawerLang && drawerLangDropdown) {
      drawerLangBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = drawerLang.classList.contains("is-open");

        if (isOpen) {
          drawerLang.classList.remove("is-open");
          drawerLangBtn.setAttribute("aria-expanded", "false");
        } else {
          drawerLang.classList.add("is-open");
          drawerLangBtn.setAttribute("aria-expanded", "true");
        }
      });

      // 외부 클릭 시 닫기
      document.addEventListener("click", (e) => {
        if (!drawerLang.contains(e.target)) {
          drawerLang.classList.remove("is-open");
          drawerLangBtn.setAttribute("aria-expanded", "false");
        }
      });
    }
  }
}

// Lenis 인스턴스 전역 변수
let lenisInstance = null;

function initLenis() {
  lenisInstance = new Lenis();
  window.lenis = lenisInstance; // 전역 접근 가능하도록

  lenisInstance.on("scroll", ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenisInstance.raf(time * 1000);
  });

  gsap.ticker.lagSmoothing(0);

  return lenisInstance;
}

// Before-After Swiper 인스턴스 전역 변수
let beforeAfterSwiper = null;

// Before-After 데이터는 서버에서 window.beforeAfterData로 전달됨
// window.isLoggedIn으로 로그인 상태 확인

// Before-After Swiper 슬라이드 생성 함수
function createBeforeAfterSlides(data) {
  if (!data || data.length === 0) {
    return '<li class="swiper-slide"><div class="before-after-swiper__item" style="text-align: center; padding: 40px;"><p>등록된 케이스가 없습니다.</p></div></li>';
  }

  const isLoggedIn = window.isLoggedIn || false;
  const loginUrl = "/auth/login";

  return data
    .map(
      (item) => `
    <li class="swiper-slide">
      <a href="/reservation/cases/view?no=${item.id}" 
         class="before-after-swiper__item ${!isLoggedIn ? "require-login" : ""}"
         ${!isLoggedIn ? 'data-require-login="true"' : ""}>
        <figure class="before-after-swiper__image before-after-swiper__image--before">
          <img src="${item.before}" alt="Before">
          <span class="before-after-swiper__label f-body-3 --fm-en">Before</span>
        </figure>
        <figure class="before-after-swiper__image before-after-swiper__image--after">
          <img src="${item.after}" alt="After">
          ${
            !isLoggedIn
              ? `
          <div class="before-after-swiper__after-bg">
            <i class="fa-regular fa-lock"></i>
            <span class="f-body-1 --fm-ko">로그인 후 확인하기</span>
          </div>
          `
              : ""
          }
          <span class="before-after-swiper__label f-body-3 --fm-en">After</span>
        </figure>
      </a>
    </li>
  `
    )
    .join("");
}

// Before-After Swiper 업데이트 함수
function updateBeforeAfterSwiper(branch) {
  const swiperEl = document.getElementById("before-after-swiper");
  if (!swiperEl) return;

  // window.beforeAfterData에서 데이터 가져오기
  const allData = window.beforeAfterData || {};
  const data = allData[branch] || allData.gangnam || [];
  const wrapper = swiperEl.querySelector(".swiper-wrapper");

  if (!wrapper) return;

  // 기존 슬라이드 제거 후 새 슬라이드 추가
  wrapper.innerHTML = createBeforeAfterSlides(data);

  // 로그인 필요 링크 클릭 이벤트 바인딩
  initBeforeAfterLoginLinks();

  // Swiper가 이미 초기화되어 있으면 업데이트, 없으면 새로 생성
  if (beforeAfterSwiper) {
    // 기존 인스턴스 제거
    beforeAfterSwiper.destroy(true, true);
    beforeAfterSwiper = null;
  }

  // 새로 Swiper 초기화
  beforeAfterSwiper = new Swiper(swiperEl, {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: false,
    pagination: {
      el: ".before-after-swiper__progressbar",
      type: "progressbar",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 48,
      },
    },
  });
}

// Before-After 로그인 필요 링크 클릭 이벤트 초기화
function initBeforeAfterLoginLinks() {
  bindRequireLoginToContainer(
    document,
    '.before-after-swiper__item[data-require-login="true"]',
    "/auth/login",
    "로그인이 필요합니다. 로그인 페이지로 이동하시겠습니까?"
  );
}

function initSwipers() {
  // Main Hero Swiper
  const mainHeroSwiperEl = document.getElementById("main-hero-swiper");
  if (mainHeroSwiperEl) {
    const mainHeroSwiper = new Swiper(mainHeroSwiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 1500,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".no-main-hero__pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".no-main-hero__button--next",
        prevEl: ".no-main-hero__button--prev",
      },
    });
  }

  // Services Swiper
  const servicesSwiperEl = document.getElementById("main-services-swiper");
  if (servicesSwiperEl) {
    new Swiper(servicesSwiperEl, {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 88,
      speed: 1600,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".no-main-services__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".no-main-services__button--next",
        prevEl: ".no-main-services__button--prev",
      },
    });
  }

  // Before-After Swiper (초기 데이터로 초기화)
  const beforeAfterSwiperEl = document.getElementById("before-after-swiper");
  if (beforeAfterSwiperEl && window.beforeAfterData) {
    const initialData = window.beforeAfterData.gangnam || [];
    const wrapper = beforeAfterSwiperEl.querySelector(".swiper-wrapper");
    if (wrapper) {
      // 초기 데이터로 슬라이드 생성 (이미 HTML에 렌더링되어 있을 수도 있음)
      // 하지만 탭 클릭 시 재렌더링을 위해 여기서도 처리
      if (initialData.length > 0) {
        wrapper.innerHTML = createBeforeAfterSlides(initialData);
      }
    }

    // 로그인 필요 링크 클릭 이벤트 바인딩
    initBeforeAfterLoginLinks();

    beforeAfterSwiper = new Swiper(beforeAfterSwiperEl, {
      slidesPerView: 1,
      spaceBetween: 24,
      loop: false,
      pagination: {
        el: ".before-after-swiper__progressbar",
        type: "progressbar",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 48,
        },
      },
    });
  }

  // Tab Swiper
  const tabSwiperEl = document.querySelector(".tab-swiper");
  if (tabSwiperEl) {
    new Swiper(tabSwiperEl, {
      slidesPerView: "auto",
      spaceBetween: 8,
      freeMode: true,
      breakpoints: {
        768: {
          spaceBetween: 12,
        },
        1024: {
          spaceBetween: 16,
        },
      },
    });
  }

  // Category Swiper
  const categorySwiperEl = document.querySelector(".no-category-swiper");
  if (categorySwiperEl) {
    const categorySwiper = new Swiper(categorySwiperEl, {
      slidesPerView: "auto",
      spaceBetween: 8, // 모바일 기본값
      freeMode: true,
      watchOverflow: true,
      breakpoints: {
        768: {
          spaceBetween: 12,
        },
      },
    });
  }

  // Cases Swiper (목록)
  const casesSwiperEls = document.querySelectorAll(".no-cases-swiper");

  if (casesSwiperEls.length) {
    casesSwiperEls.forEach((el) => {
      const wrapper = el.querySelector("ul");
      if (!wrapper) return;

      const pagination = el.querySelector(".no-cases-pagination");
      if (!pagination) return;

      new Swiper(el, {
        slidesPerView: 1,
        loop: true,
        speed: 600,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
      });
    });
  }

  // Case View Swiper (상세)
  const caseViewThumbSwiper = document.querySelector(
    ".no-case-view__thumb-swiper"
  );
  if (caseViewThumbSwiper) {
    const thumbSwiper = new Swiper(caseViewThumbSwiper, {
      slidesPerView: 3,
      spaceBetween: 8,
      watchSlidesProgress: true,
    });

    const caseViewMainSwiper = document.querySelector(
      ".no-case-view__main-swiper"
    );
    if (caseViewMainSwiper) {
      new Swiper(caseViewMainSwiper, {
        spaceBetween: 10,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        thumbs: {
          swiper: thumbSwiper,
        },
      });
    }
  }

  // Why Live Digital Swiper
  const whyLiveDigitalSwiperEl = document.querySelector(
    ".no-sub-why-digital__swiper"
  );
  if (whyLiveDigitalSwiperEl) {
    new Swiper(whyLiveDigitalSwiperEl, {
      slidesPerView: 3.5,
      spaceBetween: 32,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".no-sub-why-digital__next",
        prevEl: ".no-sub-why-digital__prev",
      },
      pagination: {
        el: ".no-sub-why-digital__progressbar",
        type: "progressbar",
      },
      breakpoints: {
        320: {
          slidesPerView: 1.2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 32,
        },
      },
    });
  }

  // Tour Gallery Swiper
  const thumbsSwiperEl = document.querySelector(".no-sub-tour__thumbs-swiper");
  const mainSwiperEl = document.querySelector(".no-sub-tour__main-swiper");

  if (thumbsSwiperEl && mainSwiperEl) {
    // 썸네일 스와이퍼 초기화
    const thumbsSwiper = new Swiper(thumbsSwiperEl, {
      spaceBetween: 12,
      slidesPerView: "4",
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          spaceBetween: 16,
        },
        1024: {
          spaceBetween: 20,
        },
      },
    });

    // 메인 스와이퍼 초기화 (썸네일과 연결)
    new Swiper(mainSwiperEl, {
      spaceBetween: 0,
      slidesPerView: 1,
      navigation: {
        nextEl: ".no-sub-tour__button--next",
        prevEl: ".no-sub-tour__button--prev",
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  }

  // Step Swiper
  const stepSwiperEl = document.querySelector(".no-step-swiper");
  if (stepSwiperEl) {
    const stepSwiper = new Swiper(stepSwiperEl, {
      slidesPerView: 1,
      loop: false,
      pagination: {
        el: ".no-step-swiper__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".no-step-swiper__button--next",
        prevEl: ".no-step-swiper__button--prev",
      },
      on: {
        slideChange: function () {
          const activeIndex = this.activeIndex;
          initStepPagination(activeIndex);
        },
      },
    });

    // 초기 활성화
    initStepPagination(0);
  }
}

// ============================================
// Step Pagination 초기화 (Swiper와 연동)
// ============================================
let stepPaginationInitialized = false;

function initStepPagination(activeIndex) {
  const stepSection = document.querySelector(".no-sub-step");
  if (!stepSection) return;

  const stepItems = stepSection.querySelectorAll(".step-item");
  const stepSwiperEl = stepSection.querySelector(".no-step-swiper");

  if (!stepItems.length || !stepSwiperEl) return;

  stepItems.forEach((item) => {
    item.classList.remove("--active");
  });

  // 해당 인덱스의 step-item에 active 추가
  const activeItem = stepSection.querySelector(
    `.step-item[data-step="${activeIndex}"]`
  );
  if (activeItem) {
    activeItem.classList.add("--active");
  }

  if (!stepPaginationInitialized) {
    stepItems.forEach((item, index) => {
      const head = item.querySelector(".step-head");
      if (!head) return;

      head.addEventListener("click", () => {
        const stepSwiper = stepSwiperEl.swiper;
        if (stepSwiper) {
          stepSwiper.slideTo(index);
        }
      });
    });
    stepPaginationInitialized = true;
  }
}

// Before-After 탭 클릭 이벤트 초기화
function initBeforeAfterTabs() {
  const tabContainer = document.querySelector(".no-main-before-after .--tabs");
  if (!tabContainer) return;

  const tabButtons = tabContainer.querySelectorAll("button");
  if (!tabButtons.length) return;

  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      // 모든 버튼에서 active 제거
      tabButtons.forEach((btn) => btn.classList.remove("active"));

      // 클릭한 버튼에 active 추가
      this.classList.add("active");

      // data-branch 속성에서 분기 가져오기
      const branch = this.getAttribute("data-branch") || "gangnam";

      // Swiper 재렌더링
      updateBeforeAfterSwiper(branch);
    });
  });
}

// TabManager 인스턴스 전역 변수
let tabManagerInstance = null;

// TabManager 초기화 (Lenis와 협력)
function initTabManager(lenisInstance) {
  const tabContainer = document.querySelector(".no-tab-container");
  if (!tabContainer) return;

  // TabManager 인스턴스 생성
  try {
    tabManagerInstance = new TabManager(".no-tab-container", lenisInstance);
    window.tabManager = tabManagerInstance; // 전역 접근 가능하도록 (디버깅용)
  } catch (error) {
    console.error("TabManager 초기화 실패:", error);
  }
}

function initMarquee() {
  const marquee = document.querySelectorAll(".no-marquee");

  if (!marquee) return;

  marquee.forEach((item) => {
    const marqueeInner = item.querySelector(".no-marquee__inner");
    const marqueeContent = marqueeInner.querySelector(".no-marquee__content");

    // Duration
    const duration = item.getAttribute("data-marquee-duration");

    // Element Clone
    const marqueeContentClone = marqueeContent.cloneNode(true);
    marqueeInner.append(marqueeContentClone);

    // Marquee animation
    const marqueeContentAll = marqueeInner.querySelectorAll(
      ".no-marquee__content"
    );
    marqueeContentAll.forEach((element) => {
      gsap.to(element, {
        x: "-101%",
        repeat: -1,
        duration: duration,
        ease: "linear",
      });
    });
  });
}

// Review Marquee 초기화 (2줄)
function initReviewMarquee() {
  const reviewMarquee = document.getElementById("review-marquee");
  if (!reviewMarquee) return;

  const rows = reviewMarquee.querySelectorAll(".no-main-review__marquee-row");
  if (!rows.length) return;

  rows.forEach((row) => {
    const inner = row.querySelector(".no-main-review__marquee-inner");
    if (!inner) return;

    // 방향 설정 (첫 번째 줄: 왼쪽, 두 번째 줄: 오른쪽)
    const direction = row.getAttribute("data-direction");
    const isRight = direction === "right";

    // 내부 카드 가져오기
    const cards = inner.querySelectorAll(".no-main-review__card");
    if (!cards.length) return;

    // 카드들을 복제해서 추가 (무한 반복을 위해)
    const cardsArray = Array.from(cards);
    cardsArray.forEach((card) => {
      const clone = card.cloneNode(true);
      inner.appendChild(clone);
    });

    // 첫 번째 카드의 너비와 gap 계산
    const firstCard = cards[0];
    if (!firstCard) return;

    // 리플로우 후 너비 계산
    const cardWidth = firstCard.offsetWidth;
    const gapValue = window
      .getComputedStyle(inner)
      .getPropertyValue("gap")
      .replace("px", "");
    const gap = parseFloat(gapValue) || 24;

    // 전체 너비 계산 (절반만 이동 - 복제했으므로)
    const totalWidth = (cardWidth + gap) * cards.length;

    // GSAP 애니메이션 (무한 반복)
    if (isRight) {
      // right 방향: 초기 위치를 왼쪽으로 설정하고 오른쪽으로 이동
      gsap.set(inner, { x: -totalWidth });
      gsap.to(inner, {
        x: 0,
        repeat: -1,
        duration: 80, // 속도 조절 (낮을수록 빠름)
        ease: "none",
      });
    } else {
      // left 방향: 초기 위치 0에서 왼쪽으로 이동
      gsap.to(inner, {
        x: -totalWidth,
        repeat: -1,
        duration: 80, // 속도 조절 (낮을수록 빠름)
        ease: "none",
      });
    }
  });
}

// ============================================
// Breadcrumb 드롭다운 초기화
// ============================================
function initBreadcrumb() {
  const breadcrumbMenus = document.querySelectorAll(".breadcrumb-has-menu");

  if (!breadcrumbMenus.length) return;

  breadcrumbMenus.forEach((menuItem) => {
    const toggle = menuItem.querySelector(".breadcrumb-toggle");
    const dropdown = menuItem.querySelector(".breadcrumb-menu");

    if (!toggle || !dropdown) return;

    // 클릭 이벤트 (모바일 대응)
    toggle.addEventListener("click", (e) => {
      e.stopPropagation();

      // 다른 드롭다운 닫기
      breadcrumbMenus.forEach((other) => {
        if (other !== menuItem) {
          other.classList.remove("is-open");
        }
      });

      // 현재 드롭다운 토글
      menuItem.classList.toggle("is-open");
    });

    // 외부 클릭 시 드롭다운 닫기
    document.addEventListener("click", (e) => {
      if (!menuItem.contains(e.target)) {
        menuItem.classList.remove("is-open");
      }
    });
  });
}

// ============================================
// History Timeline 초기화
// ============================================
function initHistoryTimeline() {
  const historySection = document.querySelector(".no-sub-hospital-history");
  if (!historySection) return;

  const buttonList = document.getElementById("historyButtonList");
  const contentList = document.getElementById("historyContentList");

  if (!buttonList || !contentList) return;

  // 히스토리 데이터
  const historyData = {
    "2019-current": [
      {
        year: "2021",
        events: [
          { month: "06", desc: "2021 고용노동부 강소기업 선정" },
          { month: "05", desc: "개원 10년차 강남점 라이브치과병원" },
          { month: "03", desc: "인천점 라이브치과병원 기공소 개설" },
        ],
      },
      {
        year: "2020",
        events: [
          { month: "12", desc: "가족친화 우수기업선정" },
          { month: "12", desc: "강남구 의료관광 협력기관 위촉" },
          { month: "07", desc: "라이브치과병원 (강남점) 확장이전" },
          {
            month: "03",
            desc: "라이브빌딩 코로나19극복 '착한 임대료운동' 동참",
          },
        ],
      },
      {
        year: "2019",
        events: [
          { month: "11", desc: "노사파트너십 고용노동부 장관상 수상" },
          { month: "11", desc: "라이브오랄스 근무혁신 우수기업 장관상 수상" },
          {
            month: "07",
            desc: "교정 마무리 5,000명 갱신 (강남 3,400명 / 인천 1,700명)",
          },
          { month: "05", desc: "인천 라이브 교정마무리 1,600명 갱신" },
          {
            month: "05",
            desc: "미래산업분야 최재봉 교수 강연 콘서트 개최/기부",
          },
          {
            month: "05",
            desc: "폴포츠 내한 자선공연 개회/기부 (라이브치과병원, 서울특별시)",
          },
          { month: "04", desc: "노사발전재단 – 노사파트너십 지원사업 선정" },
          { month: "03", desc: "일가정양립 유연근무제 정부지원사업 승인" },
          { month: "02", desc: "강남 라이브 교정마무리 3,000명 갱신" },
          { month: "01", desc: "라이브치과 기공소 연구소 설립" },
          {
            month: "01",
            desc: "라이브치과병원 강남/인천 디지털 진료시스템 시행",
          },
        ],
      },
    ],
    "2017-2018": [
      {
        year: "2018",
        events: [
          { month: "12", desc: "라이브그룹 봉사기금 누적액 \\100,000,000원" },
          { month: "12", desc: "임플란트 5,000개 식립" },
          {
            month: "12",
            desc: "중소기업 유럽 헝가리 Natur-all 구강제품 LIVE ORALS 수출",
          },
          { month: "11", desc: "제5회 연탄 나눔 봉사" },
          {
            month: "09",
            desc: "교정환자 8,000명 갱신 (강남 5,000명 / 인천 3,000명)",
          },
          {
            month: "04",
            desc: "라이브치과병원 (인천점) 병원급 의료기관 보건복지부 승인",
          },
          { month: "01", desc: "라이브치과의원 (인천점) 확장이전" },
        ],
      },
      {
        year: "2017",
        events: [
          { month: "07", desc: "라이브치과병원 CMS 시스템 도입" },
          {
            month: "07",
            desc: "보건복지부 치과병원 부문 대상 수상 (보건복지부 장관 표창)",
          },
          { month: "06", desc: "교정환자 5,000명 갱신" },
          { month: "04", desc: "임플란트 1,000개 식립" },
        ],
      },
    ],
    "2015-2016": [
      {
        year: "2016",
        events: [
          { month: "11", desc: "서초구청장 지역 발전부문 표창장 수상" },
          { month: "10", desc: "교정 칫솔 특허 등록" },
          { month: "08", desc: "교정환자 4,000명 갱신" },
          { month: "05", desc: "라이브치과 기공소 개설" },
          { month: "03", desc: "강남점 11층 확장 오픈" },
          { month: "01", desc: "제1기 라이브그룹 공개채용" },
          { month: "01", desc: "교정환자 3,000명 갱신" },
        ],
      },
      {
        year: "2015",
        events: [
          { month: "11", desc: "라이브그룹 장애인 채용" },
          { month: "09", desc: "보건의료대상 치과병원 수상" },
          { month: "07", desc: "라이브치과병원 (강남점) 확장이전 & 병원승급" },
          { month: "06", desc: "교정환자 2,000명 갱신" },
          { month: "05", desc: "치열 교정용 와이어 스텝 플라이어 특허 등록" },
          {
            month: "04",
            desc: "라이브치과 강남/인천 전원 치과위생사제 시행 운영",
          },
        ],
      },
    ],
    "2012-2014": [
      {
        year: "2014",
        events: [
          { month: "12", desc: "진료기록부 전자차트화 시행" },
          { month: "11", desc: "교정환자 1,000명 갱신" },
          { month: "08", desc: "라이브치과 인천점 개원" },
          { month: "05", desc: "사내 전산시스템 (마이라이브) 도입" },
          { month: "04", desc: "외국인 환자 유치 의료기관 (보건복지부)" },
          { month: "03", desc: "치열 교정용 와이어 스텝 플라이어 특허출원" },
        ],
      },
      {
        year: "2013",
        events: [
          { month: "08", desc: "강남구 의료관광 협력기관 선정" },
          { month: "08", desc: "<라이브치과>변경 / 상표출원" },
        ],
      },
      {
        year: "2012",
        events: [{ month: "04", desc: "대치동 봄이 오는 치과 개원" }],
      },
    ],
  };

  // 히스토리 내용 렌더링 함수
  function renderHistoryContent(period) {
    const data = historyData[period];
    if (!data) return;

    const html = `
      <div class="history-content active">
        ${data
          .map(
            (yearData) => `
          <div class="history-year">
            <div class="year-title">${yearData.year}</div>
            <div class="year-divider"></div>
            <ul class="history-events">
              ${yearData.events
                .map(
                  (event) => `
                <li class="history-event">
                  <span class="event-month">${event.month}</span>
                  <span class="event-desc">${event.desc}</span>
                </li>
              `
                )
                .join("")}
            </ul>
          </div>
        `
          )
          .join("")}
      </div>
    `;
    contentList.innerHTML = html;
  }

  // 버튼 클릭 이벤트
  const buttons = buttonList.querySelectorAll(".history-btn");
  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const period = button.getAttribute("data-period");

      // 모든 버튼에서 active 제거
      buttons.forEach((btn) => btn.classList.remove("active"));

      // 클릭된 버튼에 active 추가
      button.classList.add("active");

      // 해당 기간의 내용 렌더링
      renderHistoryContent(period);
    });
  });

  // 초기 렌더링 (기본 선택된 버튼)
  const activeButton = buttonList.querySelector(".history-btn.active");
  if (activeButton) {
    const defaultPeriod = activeButton.getAttribute("data-period");
    renderHistoryContent(defaultPeriod);
  }
}

// ============================================
// Beer Slider 초기화
// ============================================
function initBeerSlider() {
  // BeerSlider가 전역으로 로드되어 있는지 확인
  if (typeof BeerSlider === "undefined") {
    console.warn("BeerSlider가 로드되지 않았습니다.");
    return;
  }

  const beerSliders = document.querySelectorAll(".beer-slider");
  if (!beerSliders.length) return;

  beerSliders.forEach((slider) => {
    try {
      new BeerSlider(slider, {
        start: 50, // 중간에서 시작
      });
    } catch (error) {
      console.error("BeerSlider 초기화 실패:", error);
    }
  });
}

// ============================================
// Floating Aside 초기화 (예약/문의 플로팅 버튼)
// ============================================
function initFloatingAside(lenisInstance) {
  const aside = document.querySelector(".no-floating-aside");
  if (!aside) return;

  const scrollTopBtn = aside.querySelector(".no-floating-aside__scroll-top");
  if (!scrollTopBtn) return;

  // 스크롤 이벤트로 버튼 표시/숨김
  function handleScroll() {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const threshold = 300; // 300px 이상 스크롤 시 표시

    if (scrollY > threshold) {
      scrollTopBtn.classList.add("is-visible");
    } else {
      scrollTopBtn.classList.remove("is-visible");
    }
  }

  // 스크롤 이벤트 리스너
  window.addEventListener("scroll", handleScroll, { passive: true });
  handleScroll(); // 초기 상태 확인

  // 스크롤 투 탑 버튼 클릭 이벤트
  scrollTopBtn.addEventListener("click", () => {
    if (lenisInstance && typeof lenisInstance.scrollTo === "function") {
      // Lenis를 사용한 부드러운 스크롤
      lenisInstance.scrollTo(0, {
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      });
    } else {
      // Lenis가 없으면 기본 스크롤
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  });
}
